module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-5.5965b5bb.png";